import { render, staticRenderFns } from "./phone_input.vue?vue&type=template&id=5c45de78&"
import script from "./phone_input.vue?vue&type=script&lang=js&"
export * from "./phone_input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports